import React, { useState } from "react";
import { TopBarStyle } from "./TopBar.styled";
import { useNavigate } from "react-router-dom";
import ROUTE from "../../common/Routes";
import { useDispatch, useSelector } from "react-redux";
import { persistor } from "../../redux/reduxStore";
import { useDB } from "../../context/DynamoDBContext";
import {
  getTreeData1API,
  getTreeData2API,
  getTreeData3API,
} from "../../api/NavBarApi";
import { useQueryClient, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useReload } from "../../context/ReloadContext";
import Dropdown from "react-bootstrap/Dropdown";
import { setTreeDataRed } from "../../redux/TreeData/TreeDataSlice";

const TopBar = ({ authorized = false }) => {
  const userRole = useSelector((state) => state.userRoleRed);
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { dynamoDBClient, setDBClient } = useDB();
  const { setReload } = useReload();
  const dispatch = useDispatch();
  const [refreshData, setRefreshData] = useState(false);
  const [refreshData2, setRefreshData2] = useState(false);
  const [refreshData3, setRefreshData3] = useState(false);
  const [backup, setBackup] = useState([]);
  const treeDataRed = useSelector((state) => state.treeDataRed);

  const handleLogout = async () => {
    // TODO: Handle logout logic
    setDBClient(null);
    await persistor
      .purge()
      .then((res) => {})
      .catch((err) => console.error(err));
    navigate("/");
  };

  const handleError = (type) => {
    setReload(false);
    if (type === "treeData1") {
      setRefreshData(false);
      toast.error("Error Occured While Fetching Users", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }

    if (type === "treeData2") {
      setRefreshData2(false);
      toast.error("Error Occured While Fetching BaseStations", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }

    if (type === "treeData3") {
      setRefreshData3(false);
      toast.error("Error Occured While Fetching Beacons", {
        bodyClassName: "notification-div-error",
        progressClassName: "progress-bar-error",
      });
    }
  };

  const { status: treeData1Status, data: treeData1 } = useQuery({
    queryKey: ["treeData1"],
    queryFn: () => getTreeData1API(dynamoDBClient, treeDataRed.sortType),
    enabled: refreshData,
    onSuccess: (data) => {
      setRefreshData(false);
      setRefreshData2(true);

      queryClient.fetchQuery(["treeData2"], () =>
        getTreeData2API(dynamoDBClient, data)
      );
    },
    onError: (error) => {
      console.log("treeData1 :", error);
      handleError("treeData1");
    },
  });
  const { status: treeData2Status, data: treeData2 } = useQuery({
    queryKey: ["treeData2"],
    queryFn: () => getTreeData2API(dynamoDBClient, treeData1),
    enabled: refreshData2,
    onSuccess: (data) => {
      setRefreshData2(false);
      setRefreshData3(true);
      queryClient.fetchQuery(["treeData3"], () =>
        getTreeData3API(dynamoDBClient, data)
      );
    },
    onError: (error) => {
      console.log("treeData2 :", error);
      handleError("treeData2");
    },
  });

  const { status: treeData3Status, data: treeData3 } = useQuery({
    queryKey: ["treeData3"],
    queryFn: () => getTreeData3API(dynamoDBClient, treeData2),
    enabled: refreshData3,
    onSuccess: (data) => {
      setRefreshData3(false);
      dispatch(setTreeDataRed(data));
      setReload(false);
    },
    onError: (error) => {
      console.log("treeData3 :", error);
      handleError("treeData3");
    },
  });

  // if(treeData1Status==="error" || treeData2Status === "error" || treeData3Status === "error"){
  // if(treeData1Status==="error" || treeData2Status === "error" || treeData3Status === "error"){

  //   setRefreshData3(false)
  //   setReload(false)
  // }
  // if(treeData1Status==="error"){
  //   setRefreshData(false)
  //   toast.error("Error Occured While Fetching Users",{
  //     bodyClassName:"notification-div-error",
  //     progressClassName:"progress-bar-error"
  //   })
  // }
  // if(treeData2Status==="error"){
  //   setRefreshData2(false)
  //   toast.error("Error Occured While Fetching BaseStations",{
  //     bodyClassName:"notification-div-error",
  //     progressClassName:"progress-bar-error"
  //   })
  // }
  // if(treeData3Status==="error"){
  //   setRefreshData3(false)
  //   toast.error("Error Occured While Fetching Beacons",{
  //     bodyClassName:"notification-div-error",
  //     progressClassName:"progress-bar-error"
  //   })
  // }
  //   setRefreshData3(false)
  //   setReload(false)
  // }
  // if(treeData1Status==="error"){
  //   setRefreshData(false)
  //   toast.error("Error Occured While Fetching Users",{
  //     bodyClassName:"notification-div-error",
  //     progressClassName:"progress-bar-error"
  //   })
  // }
  // if(treeData2Status==="error"){
  //   setRefreshData2(false)
  //   toast.error("Error Occured While Fetching BaseStations",{
  //     bodyClassName:"notification-div-error",
  //     progressClassName:"progress-bar-error"
  //   })
  // }
  // if(treeData3Status==="error"){
  //   setRefreshData3(false)
  //   toast.error("Error Occured While Fetching Beacons",{
  //     bodyClassName:"notification-div-error",
  //     progressClassName:"progress-bar-error"
  //   })
  // }

  const reload = async () => {
    const newTree = localStorage.getItem("treeData");
    const data = JSON.parse(newTree);
    setBackup(data);
    toast("Refreshing Data");
    setReload(true);
    setRefreshData(true);
  };

  const reseller = () => {
    navigate(ROUTE.Reseller);
  };

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <i
      className="bi bi-three-dots-vertical dotStyles"
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    ></i>
  ));

  const coupon = () => {
    navigate(ROUTE.Coupon);
  };

  const sponsors = () => {
    navigate(ROUTE.Analytics);
  };

  const warranty = () => {
    navigate(ROUTE.Warranty);
  };
  const demo = () => {
    navigate(ROUTE.DemoPage);
  };
  const configure = () => {
    navigate(ROUTE.Configuration);
  };
  const sendCustomMessage = () => {
    navigate(ROUTE.CustomMessage);
  };
  const userReports = () => {
    navigate(ROUTE.UserReports);
  };

  const sendSmsNotifications = () => {
    navigate(ROUTE.SmsNotifications);
  };

  const auditLogs = () => {
    navigate(ROUTE.AuditLogs);
  };

  return (
    <TopBarStyle>
      <div className="top-container">
        <div
          className="container-1"
          onClick={() => {
            if (authorized) {
              navigate(ROUTE.Home);
            }
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/headerLogo.svg`}
            alt="Logo"
            className="logo2"
          />
        </div>
        {authorized && (
          <div className="container-2">
            <h2 className="space text-topbar">{userRole.name}</h2>

            {/* <img src="favicon.ico" alt="User Avatar" className="rounded-circle person space" width="40" height="40" /> */}
            {userRole.role !== "3" && userRole.role !== "2" ? (
              <i
                title="Register"
                className="bi bi-person-fill-add add-user space"
                onClick={() => navigate(ROUTE.Register)}
              ></i>
            ) : (
              ""
            )}
            {/* {userRole.role !== "3"  ? <i title='Register' className="bi bi-person-fill-add add-user space" onClick={()=>navigate(ROUTE.Register)}></i>:"" } */}
            {/* <i
              title="Sponsors"
              alt="Sponsors"
              onClick={sponsors}
              className="bi bi-people space reload-icon-style"
            ></i> */}
            {/* <img
              title="Promo Codes"
              src={`${process.env.PUBLIC_URL}/discount.png`}
              className="discount-icon-style space"
              alt="Discount"
              onClick={coupon}
            /> */}
            {/* <i
              title="Reseller"
              className="bi bi-person-plus space reload-icon-style"
              onClick={reseller}
            ></i> */}
            {/* <i title="Demo" className="bi bi-graph-up space demo-icon-style" onClick={demo}></i> */}
            <i
              title="Configurations"
              className="bi bi-sliders space demo-icon-style"
              onClick={configure}
            ></i>
            <i
              title="Custom Message"
              className="bi bi-send space demo-icon-style"
              onClick={sendCustomMessage}
            ></i>
            <i
              title="User Reports"
              className="bi bi-file-earmark-arrow-down space demo-icon-style"
              onClick={userReports}
            ></i>
            <i
              title="Sms Notifications"
              className="bi bi-chat-left-dots space demo-icon-style"
              onClick={sendSmsNotifications}
            ></i>
            <i
              title="Audit Logs"
              className="bi bi-journal-text space space-large demo-icon-style"
              onClick={auditLogs}
            ></i>
            {/* <i title='Warranty' className="bi bi-shield-check space reload-icon-style" onClick={warranty}></i> */}
            <i
              title="Reload"
              className="bi bi-arrow-clockwise space reload-icon-style"
              onClick={reload}
            ></i>
            <i
              title="Logout"
              className="bi bi-power logout-style"
              onClick={handleLogout}
            ></i>
            <Dropdown className="dropDownVisible">
              <Dropdown.Toggle
                as={CustomToggle}
                id="dropdown-custom-components"
              ></Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item eventKey="1" className="droptext">
                  {userRole.name}
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="2"
                  className="droptext"
                  onClick={reload}
                >
                  Reload
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="3"
                  className="droptext"
                  onClick={reseller}
                >
                  Reseller
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="4"
                  className="droptext"
                  onClick={reseller}
                >
                  Promo Codes
                </Dropdown.Item>
                {/* <Dropdown.Item eventKey="5" className='droptext' onClick={warranty} >Warranty</Dropdown.Item> */}
                {/* <Dropdown.Item eventKey="6" className='droptext' onClick={demo} >Demo</Dropdown.Item> */}
                <Dropdown.Item
                  eventKey="5"
                  className="droptext"
                  onClick={configure}
                >
                  Configurations
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="6"
                  className="droptext"
                  onClick={sendCustomMessage}
                >
                  Custom Message
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="7"
                  className="droptext"
                  onClick={userReports}
                >
                  User Reports
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="8"
                  className="droptext"
                  onClick={sendSmsNotifications}
                >
                  Sms Notifications
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="9"
                  className="droptext"
                  onClick={sponsors}
                >
                  Sponsors
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="10"
                  className="droptext"
                  onClick={auditLogs}
                >
                  Audit Logs
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="11"
                  className="droptext"
                  onClick={handleLogout}
                >
                  Logout
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        )}
      </div>
    </TopBarStyle>
  );
};

export default TopBar;
